/*
 * ****************************************************************
 * File: callInProgress.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Prathik Pai
 *
 * ****************************************************************
 */

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Typography,
  Paper,
  Card,
  Avatar,
  Grid,
  Switch,
  FormControlLabel,
  withStyles,
  useMediaQuery,
  useTheme,
  Tooltip,
  Icon,
  makeStyles,
} from "@material-ui/core";
import userIcon from "../../assets/User_Icon.svg";
import Calling_Icon from "../../assets/calls/Calling Icon.svg";
import End_Call from "../../assets/calls/End Call.svg";
import Unmute_Audio from "../../assets/calls/Unmute Audio.svg";
import Unmute_Video from "../../assets/calls/Unmute Video.svg";
import Mute_white from "../../assets/calls/Mute_white.svg";
import Audio_Icon from "../../assets/calls/Audio_Icon.svg";
import Video_Icon from "../../assets/calls/Debug_Icon.svg";
import Keypad_Gray from "../../assets/calls/Keypad_Gray.svg";
import Keypad_white from "../../assets/calls/Keypad_white.svg";
import Video_Call_Blue from "../../assets/calls/Video_call.svg";
import { useHistory } from "react-router-dom";
import VirtualKeypad from "../home/keyboard";
import { toast } from "react-toastify";
import useWindowSize from "../../components/dimension";
import { CancelPresentation, Close, ScreenShare, close } from "@material-ui/icons";
import styles from "./draggable.css";
import Drawer from "@material-ui/core/Drawer";
import "./translationList.css";
// import VideoLayout from '../home/video1';

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 38,
    height: 26,
    padding: 3,
    display: "flex",
  },
  switchBase: {
    padding: 5,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: "#314B9F",
        borderColor: "#314B9F",
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 14 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);
const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    /* bottom: 0; */
  },
  drawerPaper: {
    width: drawerWidth,
    flexShrink: 0,
    width: "300px",
    marginTop: "7.5%",
    marginRight: "1rem",
    backgroundColor: "#cacde4",
    height: "82% !important",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },

  transcribeFrame: {
    background: "white",
  },
  closeIconParent: {
    position: 'absolute',
    top: '17%',
    right: '3%',
    zIndex: 1,
    width: '19%',
    display: 'flex',
    justifyContent: 'space-between'

  }
}));

function HandleCall({
  session,
  endCall,
  acceptCall,
  remoteStream,
  localStream,
  debugLogs,
  engageClient,
  collocation,
  setCollocation,
  conferenceLayout,
  toggleTranscribe,
  setToggleTranscribe
}) {
  const remoteStreamRef = useRef(null);
  const localStreamRef = useRef(null);
  const [isAudioCall, setIsAudioCall] = useState(true);
  const [audioStatus, setAudioStatus] = useState(true);
  const [videoStatus, setVideoStatus] = useState(false);
  const [time, setTime] = useState(Number(localStorage.getItem("time")) || 0);
  const [keypad, setKeypad] = React.useState(false);
  const [username, setusername] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [toggleSwitch, setToggleSwitch] = React.useState(false);
  const [shareOption, setShare] = React.useState(false);
  const history = useHistory();
  const size = useWindowSize();
  // BreakPoints
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("xs"));
  const [seconds, setSeconds] = useState(0);
  const [minute, setMiute] = useState(0);
  const classes = useStyles();

  let sec = parseInt(localStorage.getItem("seconds")) || 0;
  const incrementTimer = () => {
    sec += 1;
    let second = sec % 60;
    let minute = sec / 60;
    setSeconds(second);
    setMiute(parseInt(minute));
  };
  useEffect(() => {
    if (isMatch === true) {
      setPositioning({
        x: size.width - 150,
        y: size.height - 310,
        init: null,
        dragging: false,
      });
    } else {
      setPositioning({ x: 10, y: 10, init: null, dragging: false });
    }
  }, [isMatch, size]);

  const [positioning, setPositioning] = React.useState({
    x: 10,
    y: 10,
    init: null,
    dragging: false,
  });

  useEffect(() => {
    // Decide if its a audio or a video call
    const { session: instance, incoming } = session;
    if (instance) {
      if (incoming) {
        if (instance.isIncomingCallWithVideo()) {
          setIsAudioCall(false);
        } else {
          setIsAudioCall(true);
        }
      } else {
        if (session["constraints"]["video"]) {
          setIsAudioCall(false);
        } else {
          setIsAudioCall(true);
        }
      }
    }
  }, []);

  const onDragContinue = (e) => {
    if (!positioning.dragging) return;
    const localStreamBox = document.getElementById("node");
    const dialogWidth = localStreamBox.clientWidth;
    const dialogHeight = localStreamBox.clientHeight;
    const x = Math.min(
      Math.max(0, e.pageX - positioning.init.x),
      window.innerWidth - dialogWidth - 60
    );
    const y = Math.min(
      Math.max(0, e.pageY - positioning.init.y),
      window.innerHeight - dialogHeight - 230
    );
    setPositioning({ ...positioning, x: x, y: y });
    e.preventDefault();
  };

  const onDragStart = (e) => {
    if (e.button !== 0) return;
    setPositioning({
      ...positioning,
      dragging: true,
      init: {
        x: e.pageX - positioning.x,
        y: e.pageY - positioning.y,
      },
    });
    e.preventDefault();
  };
  const onDragEnd = (e) => {
    setPositioning({ ...positioning, dragging: false });
    e.preventDefault();
  };

  const screenShareEnabled = engageClient?.getConfig()?.screenShareEnabled;

  useEffect(() => {
    if (remoteStreamRef && remoteStreamRef.current) {
      if (remoteStream) {
        if (remoteStream.getVideoTracks().length > 0) {
          remoteStream.getVideoTracks()[0].enabled = false;
        }
        remoteStreamRef.current.onloadedmetadata = function () {
          const tracks = remoteStream.getVideoTracks();
          for (let i = 0; i < tracks.length; ++i) {
            tracks[i].enabled = true;
          }
        };
      }
      remoteStreamRef.current.srcObject = null;
      remoteStreamRef.current.srcObject = remoteStream;
    }
  }, [remoteStream]);

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setTime((time) => time + 10);
    }, 10);

    return () => {
      clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    let interval = null;
    interval = setInterval(incrementTimer, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (session.session?._callState === "connected")
      localStorage.setItem("time", time);
  }, [time]);
  useEffect(() => {
    if (localStreamRef && localStreamRef.current) {
      localStreamRef.current.srcObject = null;
      localStreamRef.current.srcObject = localStream;
    }
  }, [localStream]);

  const toggleVideo = () => {
    /*
     *   Local Mute the Video, the remote user will be receiving a blank screen
     */
    const { session: instance } = session;
    if (instance && instance.getCallState() === "connected") {
      if (!instance.hasRemoteVideo()) {
        instance.addVideo();
      } else {
        try {
          instance.toggleVideo();
        } catch (e) {
          console.log("Toggle Video went into Exception", e.errorMessage);
          toast.error(`Toggle Video Failed : ${e.errorMessage}`);
          debugLogs.current.push(
            `Toggle Video went into Exception, ${e.errorMessage}`
          );
        }
      }
    }
  };

  const toggleAudio = () => {
    const { session: instance } = session;
    if (instance && instance.getCallState() === "connected") {
      debugLogs.current.push("Call: Toggle Audio Applied");
      try {
        instance.toggleAudio();
      } catch (e) {
        console.log("Toggle Audio went into Exception", e.errorMessage);
        toast.error(`Toggle Audio Failed : ${e.errorMessage}`);
        debugLogs.current.push(
          `Toggle Audio went into Exception, ${e.errorMessage}`
        );
      }
    }
  };

  useEffect(() => {
    if (session.session === null && collocation === "collocation") {
      localStorage.setItem("seconds", sec);
      history.push("/callinprogress.");
    } else if (session.session === null) {
      localStorage.removeItem("time");
      localStorage.removeItem("seconds");
      history.push("/home");
    }
  }, [session]);

  const mutedEvent = ({ audio, video }) => {
    if (audio) {
      debugLogs.current.push("Call[Event]: Muting the Audio");
      setAudioStatus(false);
    }
    if (video) {
      debugLogs.current.push("Call[Event]: Muting the Video");
      setVideoStatus(false);
    }
  };

  const unMutedEvent = ({ audio, video }) => {
    if (audio) {
      debugLogs.current.push("Call[Event]: UnMuting the Audio");
      setAudioStatus(true);
    }
    if (video) {
      debugLogs.current.push("Call[Event]: UnMuting the Video");
      setVideoStatus(true);
    }
  };

  const localVideoAdded = ({ stream }) => {
    const localStreamRef = document.getElementById("localStream");
    if (localStreamRef) {
      localStreamRef.srcObject = null;
      localStreamRef.srcObject = stream;
    }
    //    setVideoStatus(true);
    setIsAudioCall(false);
    toast.info("Local Video Added");
    debugLogs.current.push("Call[Event]: Added Local Video");
  };

  const remoteVideoAdded = ({ stream }) => {
    const remoteStreamRef = document.getElementById("remoteStream");
    if (remoteStreamRef) {
      stream.getVideoTracks()[0].enabled = false;
      remoteStreamRef.onloadedmetadata = function () {
        const tracks = stream.getVideoTracks();

        for (let i = 0; i < tracks.length; ++i) {
          tracks[i].enabled = true;
        }
      };
      remoteStreamRef.srcObject = null;
      remoteStreamRef.srcObject = stream;
    }

    debugLogs.current.push("Call[Event]: Added Remote Video");
  };

  const localVideoRemoved = ({ stream }) => {
    const localStreamRef = document.getElementById("localStream");
    if (localStreamRef) {
      localStreamRef.srcObject = null;
      localStreamRef.srcObject = stream;
    }
    setVideoStatus(false);
    debugLogs.current.push("Call[Event]: Removed Local Video");
  };

  const remoteVideoRemoved = ({ stream }) => {
    const remoteStreamRef = document.getElementById("remoteStream");
    if (remoteStreamRef) {
      remoteStreamRef.srcObject = null;
      remoteStreamRef.srcObject = stream;
      setIsAudioCall(true);
    }

    debugLogs.current.push("Call[Event]: Removed Remote Video");
  };

  const screensharestarted = () => {
    setShare(true);
    debugLogs.current.push("Call[Event]: Screen Video Shared");
    toast.info("Screen share started");
  };

  const screensharestopped = ({ stream }) => {
    setShare(false);
    debugLogs.current.push("Call[Event]: Screen Video unshared");
    toast.info("Screen share Stoped");
  };

  const iceConnectionStateChanged = (data) => {
    debugLogs.current.push(
      `Call[Event]: Ice Connection State changed to ${data}`
    );
    toast.info(`ice connection state - ${data}`);
  };
  useEffect(() => {
    const { session: instance } = session;
    if (instance) {
      instance.addEventHandler("muted", mutedEvent);
      instance.addEventHandler("unmuted", unMutedEvent);
      instance.addEventHandler("localvideoadded", localVideoAdded);
      instance.addEventHandler("remotevideoadded", remoteVideoAdded);
      instance.addEventHandler("localvideoremoved", localVideoRemoved);
      instance.addEventHandler("remotevideoremoved", remoteVideoRemoved);
      instance.addEventHandler("screensharestarted", screensharestarted);
      instance.addEventHandler("screensharestopped", screensharestopped);
      instance.addEventHandler(
        "iceconnectionstatechanged",
        iceConnectionStateChanged
      );
    }
    return () => {
      try {
        if (instance) {
          instance.removeEventHandler("muted", mutedEvent);
          instance.removeEventHandler("unmuted", unMutedEvent);
          instance.removeEventHandler("localvideoadded", localVideoAdded);
          instance.removeEventHandler("remotevideoadded", remoteVideoAdded);
          instance.removeEventHandler("localvideoremoved", localVideoRemoved);
          instance.removeEventHandler("remotevideoremoved", remoteVideoRemoved);
          instance.removeEventHandler("screensharestarted", screensharestarted);
          instance.removeEventHandler("screensharestopped", screensharestopped);
          instance.removeEventHandler("iceconnectionstatechanged", "");
        }
      } catch (e) { }
    };
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setKeypad(!keypad);
  };

  const handleChange = (event) => {
    const { session: instance, incoming, ringing } = session;
    if (instance) {
      if (ringing & incoming) {
        if (event.target.checked) {
          sessionStorage.setItem("videoFlag", true);
        } else {
          sessionStorage.setItem("videoFlag", false);
        }
        setToggleSwitch(event.target.checked);
      }
      if (!ringing) {
        if (event.target.checked) {
          instance.removeVideo();
          setIsAudioCall(true);
        }
      }
    }
  };

  useEffect(() => {
    const { session: instance, incoming } = session;
    if (instance && session.ringing) {
      if (incoming) {
        setToggleSwitch(false);
      }
    }
    if (instance && !session.ringing) {
      if (incoming) {
        if (sessionStorage.getItem("videoFlag") === "true") {
          setIsAudioCall(true);
        }
        setToggleSwitch(false);
      }
    }
  }, [session.ringing]);

  const manageIcon = () => {
    const { session: instance } = session;
    if (instance) {
      if (isAudioCall) {
        return <img style={{ maxWidth: "90px" }} src={Calling_Icon} />;
      }
      return <img style={{ maxWidth: "100px" }} src={Video_Call_Blue} />;
    }
    return null;
  };

  function openForm() {
    document.getElementById("myForm").style.display = "block";
  }

  function closeForm() {
    document.getElementById("myForm").style.display = "none";
  }

  const oncloseIframe = () => {
    // const iframe = document.getElementById('transcribe');
    // iframe.remove()
    setToggleTranscribe(false)
  }


  const viewToggle = () => {
    const { session: instance, ringing, incoming } = session;
    if (instance) {
      if (
        (incoming && ringing && instance.isIncomingCallWithVideo()) ||
        (!isAudioCall && !ringing)
      ) {
        return (
          <div
            style={
              conferenceLayout
                ? {
                  display: "flex",
                  flexDirection: "row",
                  padding: "20px",
                  textAlign: "end",
                  justifyContent: "flex-end",
                  color: "#929090",
                  position: "absolute",
                  left: "85%",
                  zIndex: 1000,
                }
                : {
                  display: "flex",
                  flexDirection: "row",
                  padding: "20px",
                  textAlign: "end",
                  justifyContent: "flex-end",
                  color: "#929090",
                  // position:"absolute",
                  // zIndex: 1000,
                }
            }
          >
            <FormControlLabel
              control={
                <AntSwitch
                  style={{
                    textTransform: "captailze",
                    fontSize: "12px",
                  }}
                  inputProps={{ "data-testid": "handleChange" }}
                  checked={toggleSwitch}
                  onChange={handleChange}
                  name="toggleSwitch"
                  color="primary"
                />
              }
              label="Audio only"
            />
          </div>
        );
      }
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          padding: "30px",
          textAlign: "end",
          justifyContent: "flex-end",
        }}
      ></div>
    );
  };

  const screenShare = () => {
    const { session: instance } = session;
    if (instance && instance.getCallState() === "connected") {
      instance.screenShare();
    }
  };

  const stopShare = () => {
    const { session: instance } = session;
    if (instance && instance.getCallState() === "connected") {
      instance.stopScreenShare();
    }
  };

  return (
    <>
      {
        <div style={{ margin: "1rem" }}>
          <div
            data-testid="test_handle_for_ut"
            onClick={() =>
              handleChange({ target: { value: "a", checked: true } })
            }
          ></div>
          <Grid
            item
            xs={12}
            justify="center"
            style={
              conferenceLayout && isMatch
                ? {
                  background: "rgb(241, 245, 248)",
                  height: "79vh",
                  flexWrap: "nowrap",
                  marginTop: "15vh",
                }
                : conferenceLayout && !isMatch
                  ? {
                    background: "#F1F5F8",
                    height: "79vh",
                    flexWrap: "nowrap",
                    marginTop: "6%",
                  }
                  : !conferenceLayout && isMatch
                    ? {
                      background: "#F1F5F8",
                      height: "79vh",
                      flexWrap: "nowrap",
                      marginTop: "15vh",
                    }
                    : {
                      background: "#F1F5F8",
                      height: "79vh",
                      flexWrap: "nowrap",
                      marginTop: "15vh",
                    }
            }
          >
            <Paper
              style={
                conferenceLayout
                  ? {
                    position: "relative",
                    margin: "auto",
                    justifyContent: "center",
                    textAlign: "center",
                    flexWrap: "nowrap",
                    height: "86vh",
                    backgroundColor: "#333",
                  }
                  : {
                    position: "relative",
                    margin: "auto",
                    justifyContent: "center",
                    textAlign: "center",
                    flexWrap: "nowrap",
                    height: "84vh",
                  }
              }
              onMouseMove={onDragContinue}
              onMouseUp={onDragEnd}
              onMouseLeave={onDragEnd}
            >
              {viewToggle()}
              <div>
                {session.ringing === true ? (
                  <Tooltip
                    style={{ marginTop: "2px" }}
                    disableFocusListener
                    title={
                      session.incoming
                        ? `${session.remoteUserName
                          ? session.remoteUserName
                          : session.remoteUser
                        }`
                        : `${session.remoteUserName
                          ? session.remoteUserName
                          : session.remoteUser
                        }`
                    }
                    placement="top"
                  >
                    <Typography
                      variant="h6"
                      style={{
                        textAlign: "center",
                        color: "#929090",
                        fontSize: isMatch ? "18px" : "24px",
                        fontWeight: "bold",
                        // textTransform: "capitalize",
                        padding: "25px",
                        marginTop: session.incoming ? "-6vh" : "-22px",
                        top: isMatch ? "30px" : "0px",
                      }}
                    >
                      {session.incoming
                        ? `${session.remoteUserName
                          ? session.remoteUserName
                          : session.remoteUser
                        }`
                        : `${session.remoteUserName
                          ? session.remoteUserName
                          : session.remoteUser
                        }`}
                    </Typography>
                  </Tooltip>
                ) : (
                  <>
                    <h5
                      className={
                        conferenceLayout
                          ? "conferenceconnectedTo"
                          : "connectedTo"
                      }
                    >
                      Connected To:
                    </h5>
                    <Tooltip
                      disableFocusListener
                      title={
                        session.incoming
                          ? `${session.remoteUserName
                            ? session.remoteUserName
                            : session.remoteUser
                          }`
                          : `${session.remoteUserName
                            ? session.remoteUserName
                            : session.remoteUser
                          }`
                      }
                      placement="top"
                    >
                      <Typography
                        variant="h6"
                        style={
                          conferenceLayout && isMatch
                            ? {
                              textAlign: "center",
                              color: "#929090",
                              fontSize: isMatch ? "18px" : "24px",
                              fontWeight: "bold",
                              // textTransform: "capitalize",
                              // padding: "25px",
                              marginTop: session.incoming ? "-6vh" : "-6vh",
                              // position: "absolute",
                              zIndex: 1,
                              /* top: 2%; */
                              // top: "7%",
                            }
                            : conferenceLayout && !isMatch
                              ? {
                                textAlign: "center",
                                color: "#929090",
                                fontSize: isMatch ? "18px" : "24px",
                                fontWeight: "bold",
                                // textTransform: "capitalize",
                                padding: "25px",
                                marginTop: "-6vh",
                                position: "absolute",
                                zIndex: 1,
                                /* top: 2%; */
                                top: "7%",
                              }
                              : {
                                textAlign: "center",
                                color: "#929090",
                                fontSize: isMatch ? "18px" : "24px",
                                fontWeight: "bold",
                                // textTransform: "capitalize",
                                padding: "25px",
                                marginTop: "-6vh",
                              }
                        }
                      >
                        <div
                          style={{ marginTop: isMatch ? "44px" : "10px" }}
                          id={"message"}
                        >
                          {session.incoming
                            ? `${session.remoteUserName
                              ? session.remoteUserName
                              : session.remoteUser
                            }`
                            : `${session.remoteUserName
                              ? session.remoteUserName
                              : session.remoteUser
                            }`}
                        </div>
                      </Typography>
                    </Tooltip>
                  </>
                )}
                {session.ringing === true ? (
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                      color: "#929090",
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginTop: "10px",
                    }}
                  >
                    {" "}
                    {session.incoming ? "Incoming..." : "Calling..."}
                  </Typography>
                ) : null}
                {session.ringing === false ? (
                  <Typography
                    variant="h6"
                    style={
                      conferenceLayout && isMatch
                        ? {
                          textAlign: "center",
                          // marginTop: "25px",
                          // marginBottom: "-5px",
                          // position: "absolute",
                          zIndex: 1,
                          // top: "10%",
                          // marginBottom:"2px",
                          left: "25%",
                          color: "#929090",
                        }
                        : conferenceLayout && !isMatch
                          ? {
                            textAlign: "center",
                            // marginTop: "-20px",
                            // marginBottom: "-5px",
                            position: "absolute",
                            zIndex: 1,
                            bottom: "0%",
                            left: "50%",
                            color: "wheat",
                          }
                          : {
                            textAlign: "center",
                            marginTop: "-20px",
                            marginBottom: "-5px",
                          }
                    }
                  >
                    {/* {`${("0" + Math.floor((time / 60000) % 60)).slice(-2)}:${(
                      "0" + Math.floor((time / 1000) % 60)
                    ).slice(-2)}`} */}
                    {`${minute < 10 ? "0" + minute : minute}:${seconds < 10 ? "0" + seconds : seconds
                      }`}
                  </Typography>
                ) : null}
                {/* Use the below code for Reconnecting */}
                {session.ringing ? (
                  // && session?.session?._autoAnswer === false
                  <div style={{ marginTop: "12vh" }}>{manageIcon()}</div>
                ) : (
                  <div
                    style={
                      conferenceLayout
                        ? {
                          position: "absolute",
                          width: "100%",
                          top: "0",
                        }
                        : {}
                    }
                  >
                    <video
                      ref={remoteStreamRef}
                      autoPlay
                      loop
                      playsInline
                      id="remoteStream"
                      style={
                        isMatch
                          ? {
                            objectFit: "contain",
                            minHeight: "70%",
                            width: "100%",
                            maxHeight: "70vh",
                            // maxWidth: "100%",
                            justifyContent: "center",
                            // marginTop: "5vh",
                          }
                          : {
                            objectFit: "contain",
                            // minHeight: "49%",
                            // minWidth: "63%",
                            // maxHeight: "43vh",
                            // maxWidth: "63%",
                            justifyContent: "center",
                            marginTop: "1vh",
                            // border:"5px solid orange",
                            marginBottom: "5vh",
                          }
                      }
                      className={
                        conferenceLayout
                          ? "videoElement"
                          : "videoElementConference"
                      }
                    />
                  </div>
                )}
                {/* eslint-disable no-constant-condition  */}

                {true ? (
                  <div
                    id={"node"}
                    className={"top-row"}
                    onMouseDown={onDragStart}
                    style={{
                      top: positioning.y + "px",
                      left: positioning.x + "px",
                      cursor: "move",
                      position: "absolute",
                    }}
                  >
                    <div
                      style={{
                        minWidth: isMatch ? "6%" : "150px",
                        maxHeight: isMatch ? "80px" : "120px",
                        // background: "#B7B7B74A",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {/* eslint-disable no-constant-condition  */}
                      {true ? (
                        <video
                          ref={localStreamRef}
                          id="localStream"
                          autoPlay
                          loop
                          muted
                          playsInline
                          style={{
                            objectFit: "cover",
                            margin: "auto",
                            minWidth: isMatch ? "6%" : "150px",
                            maxHeight: isMatch ? "80px" : "120px",
                            display: "flex", //isAudioCall?"none":"flex"
                          }}
                          className={conferenceLayout ? "videoElement" : null}
                        />
                      ) : (
                        <Avatar
                          style={{
                            margin: "auto",
                            width: "68px",
                            height: "68px",
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={userIcon}
                            style={{
                              width: "38px",
                              height: "38px",
                              color: "white",
                            }}
                          />
                        </Avatar>
                      )}
                    </div>
                  </div>
                ) : null}
                {/* check it for text only then you can add for grid */}
                {/* {session?.session?._autoAnswer === false ? ( */}
                <Grid xs={12} md={8} lg={8} item justifyContent="center">
                  <div
                    style={
                      session.session?._callState !== "connected" || isMatch
                        ? {
                          padding: "5px",
                          top: "auto",
                          right: 10,
                          bottom: -1,
                          left: 1,
                          position: "fixed",
                          width: "100%",
                          color: "white",
                          marginBottom: "0.5%",
                        }
                        : conferenceLayout
                          ? {
                            position: "absolute",
                            padding: "5px",
                            top: "10px",
                            right: 10,
                            left: 1,
                            width: "100%",
                            color: "white",
                          }
                          : {
                            padding: "5px",
                            top: "auto",
                            right: 10,
                            bottom: -1,
                            left: 1,
                            position: "fixed",
                            width: "100%",
                            color: "white",
                          }
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        textAlign: "center",
                        justifyContent: "center",
                        minWidth: "80%",
                        flexWrap: "nowrap",
                      }}
                    >
                      <div>
                        {session.incoming && session.ringing ? (
                          <Card
                            style={
                              conferenceLayout
                                ? {
                                  minWidth: "36px",
                                  height: "36px",
                                  background: "#01AD24",
                                  justifyContent: "center",
                                  display: "flex",
                                  margin: "0.6rem",
                                }
                                : {
                                  minWidth: "50px",
                                  height: "50px",
                                  background: "#01AD24",
                                  justifyContent: "center",
                                  display: "flex",
                                  margin: "0.6rem",
                                }
                            }
                            onClick={() =>
                              acceptCall({ audio: true, video: true })
                            }
                          >
                            <img
                              src={Audio_Icon}
                              style={{
                                color: "#707070",
                                alignSelf: "center",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              className={
                                conferenceLayout ? "videoControlIcon" : null
                              }
                            />
                          </Card>
                        ) : session.session?._callState === "connected" ? (
                          <Card
                            data-testid="toggleVideo"
                            style={{
                              minWidth: conferenceLayout ? "36px" : "50px",
                              height: conferenceLayout ? "36px" : "50px",
                              background:
                                session.session?._callState === "connected"
                                  ? " #314B9F"
                                  : "#B7B7B7",
                              justifyContent: "center",
                              display: "flex",
                              margin: "0.6rem",
                            }}
                            onClick={() => toggleVideo()}
                          >
                            {videoStatus ? (
                              <img
                                src={Video_Icon}
                                style={{
                                  color: "#707070",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                className={
                                  conferenceLayout ? "videoControlIcon" : null
                                }
                              />
                            ) : (
                              <img
                                src={Unmute_Video}
                                style={{
                                  color: "#707070",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                className={
                                  conferenceLayout ? "videoControlIcon" : null
                                }
                              />
                            )}
                          </Card>
                        ) : (
                          <Card
                            data-testid="toggleVideo"
                            style={{
                              minWidth: conferenceLayout ? "36px" : "50px",
                              height: conferenceLayout ? "36px" : "50px",
                              background: "#B7B7B7",
                              justifyContent: "center",
                              display: "flex",
                              margin: "0.6rem",
                            }}
                            onClick={() => toggleVideo()}
                          >
                            {videoStatus ? (
                              <img
                                src={Video_Icon}
                                style={{
                                  color: "#707070",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                className={
                                  conferenceLayout ? "videoControlIcon" : null
                                }
                              />
                            ) : (
                              <img
                                src={Unmute_Video}
                                style={{
                                  color: "#707070",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                className={
                                  conferenceLayout ? "videoControlIcon" : null
                                }
                              />
                            )}
                          </Card>
                        )}
                        {!conferenceLayout && (
                          <p
                            style={{
                              color: "#747474",
                              textTransform: "capitalize",
                              marginTop: "-1px",
                            }}
                          >
                            {session.incoming && session.ringing
                              ? "answer"
                              : "video"}
                          </p>
                        )}
                      </div>

                      <div>
                        <Card
                          data-testid="toggleAudio"
                          style={{
                            minWidth: conferenceLayout ? "36px" : "50px",
                            height: conferenceLayout ? "36px" : "50px",
                            background:
                              session.session?._callState === "connected"
                                ? "#01AD24"
                                : "#B7B7B7",
                            justifyContent: "center",
                            display: "flex",
                            margin: "0.6rem",
                          }}
                          onClick={() => toggleAudio()}
                        >
                          {audioStatus ? (
                            <img
                              src={Mute_white}
                              style={{
                                color: "#707070",
                                alignSelf: "center",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              className={
                                conferenceLayout ? "videoControlIcon" : null
                              }
                            />
                          ) : (
                            <img
                              src={Unmute_Audio}
                              style={{
                                color: "#707070",
                                alignSelf: "center",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              className={
                                conferenceLayout ? "videoControlIcon" : null
                              }
                            />
                          )}
                        </Card>
                        {!conferenceLayout && (
                          <p
                            style={{
                              color: "#747474",
                              textTransform: "capitalize",
                              marginTop: "-1px",
                            }}
                          >
                            Audio
                          </p>
                        )}
                      </div>

                      <div>
                        <Card
                          style={{
                            minWidth: conferenceLayout ? "36px" : "50px",
                            height: conferenceLayout ? "36px" : "50px",
                            background:
                              session.session?._callState === "connected"
                                ? "#314B9F"
                                : "#B7B7B7",
                            justifyContent: "center",
                            display: "flex",
                            margin: "0.6rem",
                          }}
                        >
                          <img
                            onClick={(e) => {
                              handleClick(e);
                              setKeypad(!keypad);
                            }}
                            src={
                              session.session?._callState === "connected"
                                ? Keypad_white
                                : Keypad_Gray
                            }
                            style={{
                              color: "#707070",
                              alignSelf: "center",
                              justifyContent: "center",
                              textAlign: "center",
                            }}
                            className={
                              conferenceLayout ? "videoControlIcon" : null
                            }
                          />
                        </Card>
                        {!conferenceLayout && (
                          <p
                            style={{
                              color: "#747474",
                              textTransform: "capitalize",
                              marginTop: "-1px",
                            }}
                          >
                            {session.session?._callState === "connected"
                              ? keypad
                                ? "hide"
                                : "keypad"
                              : "keypad"}
                          </p>
                        )}
                        {session.session?._callState === "connected" ? (
                          <VirtualKeypad
                            open={open}
                            close={handleClose}
                            anchorEl={anchorEl}
                            setusername={setusername}
                            username={username}
                            session={session}
                          />
                        ) : null}
                      </div>
                      {screenShareEnabled === true ? (
                        <div>
                          {shareOption === false ? (
                            <Card
                              style={{
                                minWidth: conferenceLayout ? "36px" : "50px",
                                height: conferenceLayout ? "36px" : "50px",
                                background:
                                  session.session?._callState === "connected"
                                    ? " #314B9F"
                                    : "#B7B7B7",
                                justifyContent: "center",
                                display: "flex",
                                margin: "0.6rem",
                              }}
                              onClick={() => screenShare()}
                            >
                              <Icon
                                style={{
                                  color: "white",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  height: "30px",
                                }}
                                className={
                                  conferenceLayout ? "videoControlIcon" : null
                                }
                              >
                                <ScreenShare />
                              </Icon>
                            </Card>
                          ) : (
                            <Card
                              style={{
                                minWidth: conferenceLayout ? "36px" : "50px",
                                height: conferenceLayout ? "36px" : "50px",
                                background:
                                  session.session?._callState === "connected"
                                    ? " #314B9F"
                                    : "#B7B7B7",
                                justifyContent: "center",
                                display: "flex",
                                margin: "0.6rem",
                              }}
                              onClick={() => stopShare()}
                            >
                              <Icon
                                style={{
                                  color: "white",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  height: "30px",
                                }}
                                className={
                                  conferenceLayout ? "videoControlIcon" : null
                                }
                              >
                                <CancelPresentation />
                              </Icon>
                            </Card>
                          )}
                          {!conferenceLayout && (
                            <p
                              style={{
                                color: "#747474",
                                textTransform: "capitalize",
                                marginTop: "-1px",
                              }}
                            >
                              {shareOption === false ? "Share" : "Unshare"}
                            </p>
                          )}
                        </div>
                      ) : null}
                      <div>
                        <Card
                          style={{
                            minWidth: conferenceLayout ? "36px" : "50px",
                            height: conferenceLayout ? "36px" : "50px",
                            background: "#DE1C4C",
                            justifyContent: "center",
                            display: "flex",
                            margin: "0.6rem",
                          }}
                          onClick={endCall}
                        >
                          <img
                            src={End_Call}
                            style={{
                              color: "#F7F7F7",
                              alignSelf: "center",
                              justifyContent: "center",
                              textAlign: "center",
                            }}
                            className={
                              conferenceLayout ? "videoControlIcon" : null
                            }
                          />
                        </Card>
                        {!conferenceLayout && (
                          <p
                            style={{
                              color: "#747474",
                              textTransform: "capitalize",
                              marginTop: "-1px",
                            }}
                          >
                            end call
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </Grid>
              </div>
            </Paper>
            {toggleTranscribe &&
              window.config?.featureFlags?.transcribe?.enable && session.session?._callState === "connected" && (
                <div
                  className={classes.drawer}
                  style={{ display: toggleTranscribe ? 'block' : 'none' }}
                >
                  <div className={classes.closeIconParent}>
                    <span style={{ fontSize: '20px', position: 'relative', top: '-2px' }}>
                      Transcript
                    </span>
                    <Icon>
                      <Close onClick={oncloseIframe} />
                    </Icon>
                  </div>
                  <div
                    id="transcribeDrawer"
                  >
                    <iframe id="transcribe"
                      src={`${window.config?.featureFlags?.transcribe?.transcribeNodeServer
                        }?user=${JSON.parse(localStorage.getItem("identity"))}&callStatus=${session.session?._callState}&transcriptVisible=${toggleTranscribe}`}
                      width="300"
                      height="700"
                      style={{ position: 'fixed', right: '2%', top: '16%', height: '82%', width: '21%' }}
                    ></iframe> 
                    </div>
                </div>
              )}
          </Grid>
        </div>
      }
    </>
  );
}

HandleCall.propTypes = {
  session: PropTypes.any,
  endCall: PropTypes.any,
  acceptCall: PropTypes.any,
  remoteStream: PropTypes.any,
  localStream: PropTypes.any,
  upgrade: PropTypes.any,
  debugLogs: PropTypes.any,
  engageClient: PropTypes.any,
  collocation: PropTypes.any,
  setCollocation: PropTypes.any,
  conferenceLayout: PropTypes.any,
  toggleTranscribe: PropTypes.any,
  setToggleTranscribe: PropTypes.any
};

export default HandleCall;
